import { mapActions, mapGetters } from 'vuex';
import infiniteLoading from 'vue-infinite-loading';
import stickyConstants from '@/helpers/stickyConstants';
import balanceHistoryItem from '@/components/balance-history/balance-history-item/balance-history-item.vue';
import contentLoaderMixin from '@/mixins/contentLoader';
import { MODALS } from '@/components/app/app-modals/app-modals';


const NO_ITEMS_MESSAGE = 'No transactions to display';
const NO_MORE_ITEMS_MESSAGE = 'No further transactions'

const BASIC_COLUMN_SET = [
  'DEPOSITS',
  'PROMOTIONS',
];

export default {
  mixins: [
    contentLoaderMixin,
  ],
  props: {
    type: {
      type: String,
    },
    items: {
      type: Array,
    },
    canLoadMore: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    balanceHistoryItem,
    infiniteLoading,
  },
  data() {
    return {
      loadedInfo: NO_ITEMS_MESSAGE,
      infiniteLoader: null,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    loaderNum() {
      return (this.isLayoutMobile) ? 2 : 5;
    },
    stickyOptions() {
      return this.isLayoutMobile ? stickyConstants.mobile : stickyConstants.desktop;
    },
    showAdditionalColumns() {
      return (!BASIC_COLUMN_SET.includes(this.type) && this.isLayoutDesktop);
    },
    amountColumnModifiers() {
      return {
        column: true,
        'text-center': true,
        'small-4': !this.showAdditionalColumns,
        'small-2': this.showAdditionalColumns,
      };
    },
    typeColumnModifiers() {
      return {
        column: true,
        'text-left': true,
        'small-4': !this.showAdditionalColumns,
        'small-3': this.showAdditionalColumns,
      };
    },
    statusColumnModifiers() {
      return {
        column: true,
        'text-right': true,
        'small-4': !this.showAdditionalColumns,
        'small-3': this.showAdditionalColumns,
      };
    },
  },
  watch: {
    items: {
      handler: 'itemsHandler',
      immediate: true,
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    onFeeInfoClick() {
      this.setCurrentSmallPopup(MODALS.SMALL_FEE_INFO);
    },
    goInfinite(infi) {
      this.infiniteLoader = infi;
      this.$emit('loading', infi);
    },
    itemsHandler(newValue, oldValue) {
      if (newValue.length > 0) {
        this.isComponentReady = true;
        if (this.infiniteLoader) {
          this.infiniteLoader.loaded();
          if (!this.canLoadMore) {
            this.infiniteLoader.complete();
          }
        }
        this.loadedInfo = NO_MORE_ITEMS_MESSAGE;
      } else if (typeof oldValue === 'undefined') {
        this.loadedInfo = NO_ITEMS_MESSAGE;
        this.isComponentReady = true;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/balance-history/balance-history.js